var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarrack = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.125 15c0 7.249-5.876 13.125-13.125 13.125S1.875 22.249 1.875 15 7.751 1.875 15 1.875 28.125 7.751 28.125 15Zm-3.937 0a9.187 9.187 0 1 1-18.375 0 9.187 9.187 0 0 1 18.375 0Zm-8.835-4.896a.5.5 0 0 0-.707 0l-4.543 4.543a.5.5 0 0 0 0 .707l4.543 4.543a.5.5 0 0 0 .707 0l4.543-4.543a.5.5 0 0 0 0-.707l-4.543-4.543Z"
})));
export default SvgBarrack;